<!-- mainBestProd -->
<div class="mainBestProd">
    <h2 class="bTit">
        <span>Allrenu Best Products</span>
        올레뉴 베스트 상품
    </h2>
    <ul class="subMenu">
        <ng-container *ngFor="let item of contentsPdtCates">
            <li><a (click)="handleClickCate(item.cateCd);" [ngClass]="item.cateCd === activeId ? 'on' : ''">{{ item.cateName }}</a></li>
        </ng-container>
    </ul>

    <ul class="ProdList">
        <ng-container *ngFor="let product of pagination ? (products | paginate : config) : products">
            <li [product]="product"></li>
        </ng-container>
    </ul>

    <!-- pagerWrap -->
    <paging class="vh-100" *ngIf="total > len" [len]="len" [page]="page" [totalItems]="total" [config]="config" [turnOnPagination]="true"
         (changePage)="onChangePage($event)" [turnOnPagination]="true"></paging>
    <!-- //pagerWrap -->
</div>
<!-- //mainBestProd -->